import { DefaultSegmentGuid } from '$config';
import type { ISegment } from '$shared/interfaces/api/ISegment';
import BaseModel from '$shared/models/BaseModel';

export class Segment extends BaseModel<ISegment> {
  public get id(): string {
    return this.response?.id;
  }

  public get name(): string {
    return this.response?.name || '';
  }

  public get isDefault(): boolean {
    return this.id === DefaultSegmentGuid;
  }

  public toCommonList(): CommonList {
    return { id: this.id, label: this.name };
  }

  static from(segment: ISegment): Segment {
    return new Segment(segment);
  }
}
